import { useEffect, useMemo } from 'react';

import { enumerateKeys } from '@/utils/enumerate-keys';

import { useEvaluatorStore } from '../store/evaluatorStore';

export const useAvailablePaths = (
  input,
  output,
  referenceOutput,
  isLoading
) => {
  const setAvailablePaths = useEvaluatorStore(
    (state) => state.setAvailablePaths
  );

  const paths = useMemo(() => {
    const mPaths: string[] = [];
    if (input) {
      mPaths.push(...enumerateKeys({ obj: input, prefix: 'input' }));
    }
    if (output) {
      mPaths.push(...enumerateKeys({ obj: output, prefix: 'output' }));
    }
    if (referenceOutput) {
      mPaths.push(
        ...enumerateKeys({ obj: referenceOutput, prefix: 'referenceOutput' })
      );
    }
    return mPaths;
  }, [input, output, referenceOutput]);

  useEffect(() => {
    if (paths.length > 0 && !isLoading) {
      setAvailablePaths(paths);
    }
  }, [paths, setAvailablePaths, isLoading]);
};
